import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { UseCaseComponent } from './use-case/use-case.component';
import { NumberOfCardsComponent } from './number-of-cards/number-of-cards.component';
import { MonthlySpendComponent } from './monthly-spend/monthly-spend.component';
import { CashWithdrawalComponent } from './cash-withdrawal/cash-withdrawal.component';
import { ExternalDepositComponent } from './external-deposit/external-deposit.component';

@NgModule({
    declarations: [
        UseCaseComponent,
        NumberOfCardsComponent,
        MonthlySpendComponent,
        CashWithdrawalComponent,
        ExternalDepositComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule,
        ReactiveFormsModule,
        NgSelectModule
    ]
})
export class ExpectedActivityStepModule { }
